export {
  $createWorkflowUserInputNode,
  $isWorkflowUserInputNode,
  WorkflowUserInputNode
} from './WorkflowUserInputNode';
export type { SerializedWorkflowUserInputNode } from './WorkflowUserInputNode';

export {
  $createWorkflowStaticContentNode,
  $isWorkflowStaticContentNode,
  WorkflowStaticContentNode
} from './WorkflowStaticContentNode';
export type { SerializedWorkflowStaticContentNode } from './WorkflowStaticContentNode';

export * from './workflowLexicalNodes.consts';
